import React, { useEffect, useState, useReducer } from 'react';
import { useAuth } from '../../Context';

import { Empty, Row, Col, Typography, Button, Space, Table, Form, Input, Modal, Spin, Tooltip, message, Popover, Avatar, Card, Switch, Select, InputNumber, Tag, Badge } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { PlusOutlined, EditOutlined, DeleteOutlined, DatabaseOutlined } from '@ant-design/icons';

import { ADD_MULTIPLEMODEL_LIST_DETAILS, ADD_MULTIPLEMODEL_LIST_DETAILS_ERROR, ADD_MULTIPLEMODEL_LIST_DETAILS_SUCCESS, DATA_GENERATIONTYPE, DATA_GENERATIONTYPE_ERROR, DATA_GENERATIONTYPE_SUCCESS, DELETE_MULTIPLEMODEL_LIST_DETAILS, DELETE_MULTIPLEMODEL_LIST_DETAILS_ERROR, DELETE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS, DETECTIONALG_LIST_ERROR, DETECTIONALG_LIST_SUCCESS, MODEL_CLASSIFICATIONS, MODEL_CLASSIFICATIONS_ERROR, MODEL_CLASSIFICATIONS_SUCCESS, MODELTYPE_LIST, MODELTYPE_LIST_ERROR, MODELTYPE_LIST_SUCCESS, MULTIPLEMODEL_LIST, MULTIPLEMODEL_LIST_DETAILS, MULTIPLEMODEL_LIST_DETAILS_ERROR, MULTIPLEMODEL_LIST_DETAILS_SUCCESS, MULTIPLEMODEL_LIST_ERROR, MULTIPLEMODEL_LIST_SUCCESS, UPDATE_MULTIPLEMODEL_LIST_DETAILS, UPDATE_MULTIPLEMODEL_LIST_DETAILS_ERROR, UPDATE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS } from './constants';


import multimodelReducer from './reducer';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';

import { useFormik } from 'formik';
import axios from 'axios';
import { InfoOutlined} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';


const { Title } = Typography;

export default function Multiplemodels() {
	const [form] = Form.useForm();	
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = {multimod : [] , details: null, pending: false, error: false , datagentype: [],modelClassificationDate: [], modeltype: [],detalg: []};
	const [data, dispatch] = useReducer(multimodelReducer, initalState);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const [ShowAddMultipleModelsModal, setShowAddMultipleModelsModal] = useState(false);
	const [ShowEditMultipleModelsModal, setShowEditMultipleModelsModal] = useState(false);
	const [showDeleteMultipleModelsModal, setShowDeleteMultipleModelsModal] = useState(false);
	const [pidsFilter, setpidsFilter] = useState();
	useAuth();
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const navigate = useNavigate();
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const {getAllEvents,eventsData , pidsData, getPids, channelData, getChannels, wellalgorithmdata, getWellAlgorithm} = useAuth();
	const [reportFilter, setFilter] = useState({pidsinfoId: null, channelId: null, 
		
	}); 	
	const [chainFilterState,setChainFilter] = useState('ALL');
	const [channelsdata, setchannels] = useState(null);
	const [ statusFilter,setStatusFilter ] = useState(null);
	const [ predictonFilter,setPredictionFilter ] = useState(null);
	// const [modelPredictionResetKey, setModelPredictionResetKey] = useState(0);

	// console.log(modelPredictionResetKey);

	let statusArray = [{value: null,
		label: langdata.ALL ?  langdata.ALL : 'ALL'
	}];

	statusArray.push({
		value : true,
		label : langdata.true ? langdata.true : 'True'  
	},{
		value : false,
		label : langdata.false ? langdata.false : 'False'  
	});


	let predictionArray = [{value: null,
		label: langdata.ALL ?  langdata.ALL : 'ALL'
	}];

	predictionArray.push({
		value : true,
		label : langdata.true ? langdata.true : 'True'  
	},{
		value : false,
		label : langdata.false ? langdata.false : 'False'  
	});

	let channels=[];

	channelData && channelData.map((item) => {
		channels.push({
			value : item.id,
			label : item.name,
		});
	});

	// const channelLabel = channels.find((item) => channelsdata == item.value)?.label;

	const handleSetChannel = (e, options) =>{
		if(options === 'channels'){
			setchannels(e);
		}
	};

	const handleToggle = (value,record)=>{
		let config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: `${api}/multiplemodels/${record.id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${authtoken}`
			},
			data: {
				'status' : value
					
			}
		}; 
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					Modal.success({ title: `${langdata && langdata.StatusUpdatedSuccessfully ? langdata.StatusUpdatedSuccessfully :'Status Updated Successfully'}` });
					loadMultiplemodels();
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	
	};

	const modelpredictionhandler = (value,option)=>{
		if(option === 'add'){
			addMultipleModelsFormik.setFieldValue('modelPrediction', value);
			addMultipleModelsFormik.setFieldValue('channelinfoId', null);
			form.setFieldValue('channelinfoId', null);
			addMultipleModelsFormik.setFieldValue('pidsinfoId', null);
			form.setFieldValue('PIDS', null);
			form.setFieldValue('modelclassificationId', null);
			addMultipleModelsFormik.setFieldValue('modelclassificationId', null);
			form.setFieldValue('modeltypeId', null);
			addMultipleModelsFormik.setFieldValue('modeltypeId', null);
			form.setFieldValue('wellalgorithmId', null);
			addMultipleModelsFormik.setFieldValue('wellalgorithmId', null);
			form.setFieldValue('datagenerationtypeId', null);
			addMultipleModelsFormik.setFieldValue('datagenerationtypeId', null);
			form.setFieldValue('confidenceThreshold', null);
			addMultipleModelsFormik.setFieldValue('confidenceThreshold', null);
			form.setFieldValue('modelPath', '');
			addMultipleModelsFormik.setFieldValue('modelPath', '');
			form.setFieldValue('curlPath', '');
			addMultipleModelsFormik.setFieldValue('curlPath', '');
			form.setFieldValue('pickleFilePath', '');
			addMultipleModelsFormik.setFieldValue('pickleFilePath', '');
			form.setFieldValue('name', '');
			addMultipleModelsFormik.setFieldValue('name', '');
			form.setFieldValue('detectionalgorithmtypeId', null);
			addMultipleModelsFormik.setFieldValue('detectionalgorithmtypeId', null);

		}else if (option==='edit'){
			updateMultipleModelsFormik.setFieldValue('modelPrediction', value);
			updateMultipleModelsFormik.setFieldValue('channelinfoId', null);
			form.setFieldValue('channelinfoId', null);
			updateMultipleModelsFormik.setFieldValue('pidsinfoId', null);
			form.setFieldValue('PIDS', null);
			form.setFieldValue('modelclassificationId', null);
			updateMultipleModelsFormik.setFieldValue('modelclassificationId', null);
			form.setFieldValue('modeltypeId', null);
			updateMultipleModelsFormik.setFieldValue('modeltypeId', null);
			form.setFieldValue('wellalgorithmId', []);
			updateMultipleModelsFormik.setFieldValue('wellalgorithmId', []);
			form.setFieldValue('datagenerationtypeId', null);
			updateMultipleModelsFormik.setFieldValue('datagenerationtypeId', null);
			form.setFieldValue('confidenceThreshold', null);
			updateMultipleModelsFormik.setFieldValue('confidenceThreshold', null);
			form.setFieldValue('modelPath', '');
			updateMultipleModelsFormik.setFieldValue('modelPath', '');
			form.setFieldValue('curlPath', '');
			updateMultipleModelsFormik.setFieldValue('curlPath', '');
			form.setFieldValue('pickleFilePath', '');
			updateMultipleModelsFormik.setFieldValue('pickleFilePath', '');
			form.setFieldValue('name', '');
			updateMultipleModelsFormik.setFieldValue('name', '');
			form.setFieldValue('detectionalgorithmtypeId', null);
			updateMultipleModelsFormik.setFieldValue('detectionalgorithmtypeId', null);
		}
		setFilter({...reportFilter,pidsinfoId:null});


	};

	const CurlenableToggle = (value,record)=>{
		let config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: `${api}/multiplemodels/${record.id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${authtoken}`
			},
			data: {
				'curlEnabled' : value
					
			}
		}; 
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					Modal.success({ title: `${langdata && langdata.CurlEnableStatusUpdatedSuccessfully ? langdata.CurlEnableStatusUpdatedSuccessfully :'CurlEnable Status Updated Successfully'}` });
					loadMultiplemodels();
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	
	};

	const Editmultimodelshandler = (record) =>{
		loadImageConfigDetails(record);
		openEditMultipleModelsConfigModal(record);
	};

	const Deletemultimodelshandler = (record) =>{
		loadImageConfigDetails(record);
		openDeleteImageConfigModal();
	};

	
	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: langdata&&langdata.PIDS?langdata.PIDS:'PIDS',
			dataIndex: 'pidsname',
			key: 'pidsname',
			render: (pidsname) => {
				return pidsname.toString().toUpperCase();
			}
		},
		{
			title: langdata&&langdata.channelName?langdata.channelName:'channel Name',
			dataIndex: 'channelname',
			key: 'channelname',
			
		},
		{
			title: langdata?.AlgorithmModelName ?? 'Algorithm/Model Name',

			dataIndex: 'modelclassname',
			key: 'modelclassname',

			render: (_, record) => (
				record.modelPrediction === false ? (
					record?.detectionalgname !== '_' ? (
						<Popover
							content={record.modelclassdescription}
							title={
								langdata && langdata.Description
									? langdata.Description
									: 'Description'
							}
							trigger="hover"
						>
							<a
								onClick={() => navigate('/detection-algorithm')}
								style={{
									cursor: 'pointer',
									color:'#A81E1E',
								}}
							>
								{record?.detectionalgname}
							</a>
						</Popover>
					) : (
						record?.detectionalgname
					)
				) : (
					record?.modelclassname !== '_' ? (
						<Popover
							content={record.modelclassdescription}
							title={
								langdata && langdata.Description
									? langdata.Description
									: 'Description'
							}
							trigger="hover"
						>
							<a
								onClick={() => navigate('/model-classification-config')}
								style={{
									cursor: 'pointer',
									color: '#179668'
								}}
							>
								{record?.modelclassname}
							</a>
						</Popover>
					) : (
						record?.modelclassname
					)
				)
			)
		},
		{
			title:langdata&&langdata.ModelClass?langdata.ModelClass:'Model Class',
			dataIndex: 'modelClass',
			key: 'modelClass',
			render: (_,{ modelClass}) => (
				modelClass && modelClass.length > 0 ? (
					modelClass.map((item, index)=>(
						<Tag  onClick={()=>navigate('/eventtypes')}  key={index}  style={{marginBottom : '5px', cursor : 'pointer'}} color={'blue'} >
							{item}
						</Tag>
				
					))) : ( <Tag color={'yellow'}>{'Nil'}</Tag>) ),
					
		},
		{
			title:langdata&&langdata.Filters?langdata.Filters:'Filters',
			dataIndex: 'wellalgorithmId',
			key: 'wellalgorithmId',
			render: (record) => (
				<Space wrap>
					{record?.length ? 
						record.map(item => {
							const alg = algoritham.find(a => a.value === item);
							return (
								<Tag color={'blue'} key={item} style={{ cursor: 'pointer' }}
									onClick={() => navigate('/filter-type')}>
									{alg?.label}
								</Tag>
							);
						}) : 
						<Tag color={ 'yellow'}>
							{'Nil'}
						</Tag>
					}
				</Space>	
			)
			
		},
		{
			title:langdata&&langdata.DataGenerationType?langdata.DataGenerationType:'Data Generation Type',
			dataIndex: 'datagenName',
			key: 'datagenName',
			render:(_,record)=>(
				<Tag color={record.datagenName ? 'green' : 'yellow'} style={{ cursor: 'pointer' }}
					onClick={() => navigate('/data-generation')}>
					{record.datagenName ? record.datagenName : 'Nil'}
				</Tag>
			)
			
		},
		{
			title:langdata&&langdata.ModelType?langdata.ModelType:'Model Type',
			dataIndex: 'modeltypeName',
			key: 'modeltypeName',
		},
		{
			title:langdata&&langdata.ConfidenceThreshold?langdata.ConfidenceThreshold:'Confidence Threshold',
			dataIndex: 'confidenceThreshold',
			key: 'confidenceThreshold',
			
		},
		{
			title:langdata&&langdata.modelPath?langdata.modelPath:'Model Path',
			key: 'modelPath',
			dataIndex: 'modelPath',
			render: (_, record) => {
				return (
					<Popover
						content={record?.curlEnabled ? record?.curlPath : record?.modelPath}
						title={record?.curlEnabled  ? 'Curl Path' : 'Model Path'}
						trigger="hover"
					>
						<Typography.Text ellipsis style={{ maxWidth: 100, cursor: 'pointer' }}>
							{record?.curlEnabled ? record?.curlPath ? record.curlPath : '-' : record?.modelPath ? record.modelPath : '-'}
						</Typography.Text>
					</Popover>
				);
			}
		},
		{
			title:langdata&&langdata.PickleFilePath?langdata.PickleFilePath:'Pickle File Path',
			dataIndex: 'pickleFilePath',
			key: 'pickleFilePath',
			render: (_, record) => {
				return (
					<Popover
						content={record?.pickleFilePath}
						title={langdata&&langdata.PickleFilePath?langdata.PickleFilePath:'Pickle File Path'}
						trigger="hover"
					>
						<Typography.Text ellipsis style={{ maxWidth: 100, cursor: 'pointer' }}>
							{record?.pickleFilePath}
						</Typography.Text>
					</Popover>
				);
			}
		},
		{
			title:langdata&&langdata.SubChainActivity?langdata.SubChainActivity:'SubChain Activity',
			dataIndex: 'mainClass',
			key: 'mainClass',
			render:(_,record)=>(
				<Tag color={record.mainClass == null || record.mainClass == '' ? 'yellow' : 'green'}>
					{record.mainClass == null || record.mainClass == '' ? 'N/A' : record.mainClass}
				</Tag>
			)
			
		},

		{
			title:langdata&&langdata.ModelPrediction?langdata.ModelPrediction:'Model Prediction',
			dataIndex: 'modelPrediction',
			key: 'modelPrediction',
			render:(_,record)=>(
				<Tag color={record.modelPrediction ? '#179668' : '#A81E1E'}
				>
					{record.modelPrediction ? 'True' : 'False'}
				</Tag>
			)
			
		},

		{
			title: `${langdata&&langdata.Status?langdata.Status:'Status'}`,
			dataIndex: 'status',
			key: 'status',
			width : 100,
		
			render: (toggle, record) => (
				<>
					<Switch size='small'  value={toggle} onChange={(value) => handleToggle(value,record,'status')} />
				</>
			),
		},

		{
			title:langdata&&langdata.CurlEnabled?langdata.CurlEnabled:'Curl Enabled',
			dataIndex: 'curlEnabled',
			key: 'curlEnabled',
			width : 100,
		
			render: (toggle, record) => (
				<>
					<Switch size='small'  value={toggle} onChange={(value) => CurlenableToggle(value,record,'curlEnabled')} />
				</>
			),
			
		},
		{
			title:langdata&&langdata.chainType?langdata.chainType:'Chain Type',
			dataIndex: 'isSubChain',
			key: 'isSubChain',
			width : 100,
		
			render:(_,record)=>(
				<Tag color={record.isSubChain ? 'purple' : 'blue'}>
					{record.isSubChain ? langdata&&langdata.subChain?langdata.subChain:'Sub Chain':  langdata&&langdata.mainChain?langdata.mainChain:'Main Chain'}
				</Tag>
			)
			
		},
	];


	if(permission === 'superadmin' || permission === 'admin' ){
		columns.push({
			title: langdata && langdata.Actions ? langdata.Actions : 'Actions',
			key: 'action',
			render: (_,record) => (
				
				<Space size="middle">
					<a title={langdata&&langdata.EditMultipleModels?langdata.EditMultipleModels:'Edit Multiple Models'} onClick={()=>{Editmultimodelshandler(record);}}><EditOutlined/></a>
					<a title={langdata&&langdata.DeleteMultipleModels?langdata.DeleteMultipleModels:'Delete Multiple Models'} onClick={()=>{Deletemultimodelshandler(record);}}><DeleteOutlined /></a>
				</Space>
				
			)
		});
	}

	const openAddVehicleStatusModal = () => {
		setShowAddMultipleModelsModal(true);
		loaddetectionalgorithm();	
	};

	const cloaseMultipleModelsModal = () => {
		setShowAddMultipleModelsModal(false);
		form.resetFields();
		addMultipleModelsFormik.resetForm();
		setFilter({...reportFilter,pidsinfoId:null});
	};

	const openEditMultipleModelsConfigModal = (record) => {
		getChannels(authtoken,record.pidsinfoId);
		setShowEditMultipleModelsModal(true);
		loaddetectionalgorithm();	
	};

	const closeEditMultipleModelsModal = () => {
		setShowEditMultipleModelsModal(false);
		updateMultipleModelsFormik.resetForm();
		form.resetFields(); 	 	 
	};

	const openDeleteImageConfigModal = () => {
		setShowDeleteMultipleModelsModal(true);
	};

	const deleteMultipleModelsStatus = () => {
		const id = parseInt(data.details.id);
    
		dispatch({ type: DELETE_MULTIPLEMODEL_LIST_DETAILS });

		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/multiplemodels/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS, payload: response});
					setShowDeleteMultipleModelsModal(false);   
					loadMultiplemodels();       
				} else {
					dispatch({type:DELETE_MULTIPLEMODEL_LIST_DETAILS_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_MULTIPLEMODEL_LIST_DETAILS_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	};

	const closeDeleteMultipleModelsModal = () => {
		setShowDeleteMultipleModelsModal(false);
	};

	

	useEffect(() => {
		if(featuresModule.multiplemodelsEnabled == false) {
			navigate('/dashboard');
		}
		
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4026);
	}, []);
	
	useEffect(()=>{
		loadpredicitonlevel();
	},[]);

	useEffect(() => {
		dispatch( { type: MULTIPLEMODEL_LIST });
      
		loadMultiplemodels();
		getPids(authtoken);
		getWellAlgorithm(authtoken);
		loaddatagenerationtype();
		loadModeltypes();

		if(pidsFilter!=null){
			getChannels(authtoken, pidsFilter);

		}

	}, [authtoken,pidsFilter, chainFilterState,channelsdata,statusFilter,predictonFilter]);


	useEffect(() => {
		getAllEvents(authtoken);
		
	}, [authtoken]);


	const loadMultiplemodels = () => {
		let pidsort = '';
		let statusSort = '';
		let predictionSort = '';

		if(statusFilter != null){
			statusSort = `&status=${statusFilter}`;
		}

		if(pidsFilter){
			pidsort = `&pidsinfoId=${pidsFilter}`;
		}

		if(predictonFilter!= null){
			predictionSort = `&modelPrediction=${predictonFilter}`;
		}

		let params ='';
		if(chainFilterState == 1){
			params = '&isSubChain=true';
		}else if(chainFilterState ==2){
			params = '&isSubChain=false';
		}

		if(channelsdata){
			params = params + `&channelinfoId=${channelsdata}`;
		}

		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/multiplemodels/?pipelineId=${parseInt(pipelineId)}&$sort[id]=-1${pidsort}${params}${statusSort}${predictionSort}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
  
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:MULTIPLEMODEL_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:MULTIPLEMODEL_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	};

	const loadImageConfigDetails = ((record) => {


		dispatch( { type: MULTIPLEMODEL_LIST_DETAILS });
    
		if (!record) {
			dispatch({ type: MULTIPLEMODEL_LIST_DETAILS_ERROR });
		} else {
			dispatch({ type: MULTIPLEMODEL_LIST_DETAILS_SUCCESS, payload: record });

		}

	});

	const handleSubChainToggle = (e,option)=>{
		if(option == 'add'){
			// setSubChainEnabled(e);
			addMultipleModelsFormik.setFieldValue('isSubChain', e);
			if(e == false){
				addMultipleModelsFormik.setFieldValue('mainClass', '');
			}
		}
		else {
			updateMultipleModelsFormik.setFieldValue('isSubChain', e);
			if(e == false){
				updateMultipleModelsFormik.setFieldValue('mainClass', '');
			}
		}
		
	};

	

	const addMultipleModelsFormik = useFormik({
		initialValues: {
			name : '',
			channelinfoId : null,
			modelclassificationId : null,
			wellalgorithmId : [],
			datagenerationtypeId : null,
			modeltypeId : null,
			modelPath : '',
			curlEnabled : false,
			status : false,
			confidenceThreshold : null,
			pidsinfoId : null,
			isSubChain : false,
			mainClass : '',
			curlPath : '',
			pickleFilePath : '',
			modelPrediction:true,
			detectionalgorithmtypeId:null
		},
		onSubmit: (values) => {
			const name = values.name ? values.name : '';
			const pidsinfoId =  values.pidsinfoId ? values.pidsinfoId : null;
			const channelinfoId = values.channelinfoId ? values.channelinfoId : null;
			const wellalgorithmId = values.wellalgorithmId ? values.wellalgorithmId : [];
			const datagenerationtypeId = values.datagenerationtypeId ? values.datagenerationtypeId : null;
			const modeltypeId = values.modeltypeId ? values.modeltypeId : null;
			const curlEnabled = values.curlEnabled ? values.curlEnabled : false;
			const modelPath = values.modelPath ? values.modelPath : '';
			const modelclassificationId = values.modelclassificationId ? values.modelclassificationId : null;
			const confidenceThreshold = values.confidenceThreshold ? values.confidenceThreshold : null;
			const modelPrediction = values.modelPrediction ?? true;
			const detectionalgorithmtypeId = values.detectionalgorithmtypeId ? values.detectionalgorithmtypeId : null;
			// const pickleFilePath = values.pickleFilePath ? values.pickleFilePath : '';

			if (!name || name == null || name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseprovideavalidactivityname ? langdata.Pleaseprovideavalidactivityname : 'Please provide a valid activity name.' });
				return false;
			}
			if (!pidsinfoId || pidsinfoId == null || pidsinfoId === 0) {
				Modal.warning({ title: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS' });
				return false;
			}

			if (!channelinfoId || channelinfoId == null || channelinfoId === 0) {
				Modal.warning({ title: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'});
				return false;
			}

			// if (!datagenerationtypeId || datagenerationtypeId == null || datagenerationtypeId === 0) {
			// 	Modal.warning({ title: langdata&&langdata.PleaseSelectDataGenerationType?langdata.PleaseSelectDataGenerationType:'Please Select Data Generation Type'});
			// 	return false;
			// }
			// if (!modeltypeId || modeltypeId == null || modeltypeId === 0) {
			// 	Modal.warning({ title: langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype :'Select model type' });
			// 	return false;
			// }
			// if (!modelclassificationId || modelclassificationId == null || modelclassificationId === 0) {
			// 	Modal.warning({ title: langdata&&langdata.PleaseSelectModelclass?langdata.PleaseSelectModelclass:'Please Select Model class' });
			// 	return false;
			// }
			// if (!confidenceThreshold || confidenceThreshold == null || confidenceThreshold === 0) {
			// 	Modal.warning({ title: langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please Enter Confidence Threshold' });
			// 	return false;
			// }
			if ((values.isSubChain == true) && (values.mainClass == '' || values.mainClass == undefined || values.mainClass == null) ) {
				Modal.warning({ title: langdata && langdata.PleaseSelectSubChainActivity ? langdata.PleaseSelectSubChainActivity : 'Please Select SubChain Activity' });
				return false;
			}
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/multiplemodels`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					channelinfoId : channelinfoId ,
					modelPath : modelPath,
					modelclassificationId : modelclassificationId,
					wellalgorithmId : wellalgorithmId,
					datagenerationtypeId : datagenerationtypeId,
					modeltypeId: modeltypeId,
					curlEnabled: curlEnabled,
					confidenceThreshold : Number(confidenceThreshold),
					pidsinfoId : pidsinfoId,
					status :  values.status ? values.status : false,
					pipelineId : parseInt( pipelineId ),
					isSubChain : values.isSubChain,
					mainClass : values.mainClass,
					curlPath : values.curlPath,
					pickleFilePath : values.pickleFilePath,
					modelPrediction:modelPrediction,
					detectionalgorithmtypeId:detectionalgorithmtypeId


				}
			};

			dispatch( { type: ADD_MULTIPLEMODEL_LIST_DETAILS });
      
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_MULTIPLEMODEL_LIST_DETAILS_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.MultiplemodelconfigAddedSuccessfully ? langdata.MultiplemodelconfigAddedSuccessfully : 'Multiplemodel Config Added Successfully' });
						setShowAddMultipleModelsModal(false);
						addMultipleModelsFormik.resetForm();
						form.resetFields();
						loadMultiplemodels();
					} else {
						dispatch({type: ADD_MULTIPLEMODEL_LIST_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToMultiplemodelconfig ? langdata.UnableToMultiplemodelconfig : 'Unable To Multiplemodel config' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_MULTIPLEMODEL_LIST_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}else{
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong'}`,
						});
					}
				});
		}
	});


	const updateMultipleModelsFormik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name : data.details ? data.details.name : '',
			channelinfoId :  data.details ? data.details.channelinfoId : 0,
			modelclassificationId :  data.details ? data.details.modelclassificationId : 0,
			wellalgorithmId : data.details ? data.details.wellalgorithmId : [],
			datagenerationtypeId : data.details ? data.details.datagenerationtypeId : null,
			modeltypeId : data.details ? data.details.modeltypeId : null,
			modelPath : data.details ? data.details.modelPath : '',
			curlEnabled : data.details ? data.details.curlEnabled : false,
			status : data.details ? data.details.status : false,
			confidenceThreshold : data.details ? data.details.confidenceThreshold : 0,
			pidsinfoId : data.details ? data.details.pidsinfoId : null,
			isSubChain : data.details ? data.details.isSubChain : false,
			mainClass : data.details ? data?.details.mainClass : '',
			curlPath : data.details ? data?.details.curlPath : '',
			pickleFilePath : data.details ? data?.details.pickleFilePath : '',
			modelPrediction: data.details ?data?.details.modelPrediction : true,
			detectionalgorithmtypeId:data.details ? data.details.detectionalgorithmtypeId : null,
			
		},
		onSubmit: (values) => {
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.Pleaseprovideavalidactivityname ? langdata.Pleaseprovideavalidactivityname : 'Please provide a valid activity name.' });
				return false;
			}
			if (!values.pidsinfoId || values.pidsinfoId == null || values.pidsinfoId === 0) {
				Modal.warning({ title: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS' });
				return false;
			}

			if (!values.channelinfoId || values.channelinfoId == null || values.channelinfoId === 0) {
				Modal.warning({ title: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'});
				return false;
			}

			if(values.isSubChain && (values.mainClass =='' || values.mainClass == undefined || values.mainClass == null)){
				Modal.warning({ title: langdata && langdata.PleaseEnterModelClass ? langdata.PleaseEnterModelClass : 'Please Enter Model Class' });
				return false;
			}
			const id = data?.details?.id;
			const name = values.name ? values.name : '';
			const channelinfoId = values.channelinfoId ? values.channelinfoId : null;
			const modelclassificationId = values.modelclassificationId ? values.modelclassificationId : null;
			const wellalgorithmId = values.wellalgorithmId ? values.wellalgorithmId : [];
			const datagenerationtypeId = values.datagenerationtypeId ? values.datagenerationtypeId : null;
			const modeltypeId = values.modeltypeId ? values.modeltypeId : null;
			const modelPath = values.modelPath ? values.modelPath : '';
			const curlEnabled = values.curlEnabled ? values.curlEnabled : false;
			const confidenceThreshold = values.confidenceThreshold ? values.confidenceThreshold : 0;
			const pidsinfoId = values.pidsinfoId ? values.pidsinfoId : null;
			const modelPrediction = values.modelPrediction;
			const detectionalgorithmtypeId = values.detectionalgorithmtypeId ? values.detectionalgorithmtypeId : null;


			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/multiplemodels/${id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					name : name,
					channelinfoId : channelinfoId ,
					modelPath : modelPath,
					modelclassificationId : modelclassificationId,
					wellalgorithmId : wellalgorithmId,
					datagenerationtypeId : datagenerationtypeId,
					modeltypeId: modeltypeId,
					curlEnabled: curlEnabled,
					confidenceThreshold : Number(confidenceThreshold),
					pidsinfoId : pidsinfoId,
					status :  values.status ? values.status : false,
					pipelineId : parseInt( pipelineId ),
					isSubChain : values.isSubChain,
					mainClass : values.mainClass,
					curlPath : values.curlPath,
					pickleFilePath : values.pickleFilePath,
					modelPrediction:modelPrediction,
					detectionalgorithmtypeId:detectionalgorithmtypeId

				}
			};

			dispatch( { type: UPDATE_MULTIPLEMODEL_LIST_DETAILS });

			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: UPDATE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS, payload:response});
						Modal.success({ title: langdata && langdata.MultipleModelsConfigUpdatedSuccessfully ? langdata.MultipleModelsConfigUpdatedSuccessfully : 'Multiple Models Config Updated Successfully' });
						setShowEditMultipleModelsModal(false);
						form.resetFields();
						updateMultipleModelsFormik.resetForm();
						loadMultiplemodels();
					}
					else {
						dispatch({type: UPDATE_MULTIPLEMODEL_LIST_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnableToUpdateMultipleModelsConfig ? langdata.UnableToUpdateMultipleModelsConfig : 'Unable To Update Multiple Models Config' });  
					}
				})
				.catch((error) => {
					dispatch({type: UPDATE_MULTIPLEMODEL_LIST_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}else{
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
						});
					}
				});
		}
	});
	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{ langdata && langdata.MultipleModelsinfoContent ? langdata.MultipleModelsinfoContent  :  'This module lists all model prediction chains and allows administrators to manage them based on model classification, filter order, chain data generation, and model type. Models can be activated or deactivated for prediction, and all configurations can be managed at the chain level.'}</p>
		</Card>
	);

	let pids=[];
	let pidsfilter=[{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` }];

	let chainFilter = [{value:null, label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}` },
		{value:1, label:`${langdata && langdata.subChain ? langdata.subChain:'Sub Chain'}`},
		{value:2, label:`${langdata && langdata.mainChain ? langdata.mainChain:'Main Chain'}`}
	];

	pidsData && pidsData.map((pid)=>{
		pids.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});
	
	pidsData && pidsData.map((pid)=>{
		pidsfilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});
	let allevents=[];
    
	eventsData && eventsData.map((item) => {
		allevents.push({
			value : item.eventType,
			label: item.eventType
		});
	});
	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());



	
	const algoritham = [];
	wellalgorithmdata && wellalgorithmdata.data.map((item) => {		
		algoritham.push({
			value : item.id,
			label : item.name
		});
	});

	const modelclassop = [];
	data?.modelClassificationDate && data?.modelClassificationDate.map((item) => {		
		modelclassop.push({
			value : item.id,
			label : item.alias
		});
	});


	const datagenop = [{value : null, label : 'Nil'}];
	data?.datagentype && data?.datagentype.map((item) => {		
		datagenop.push({
			value : item.id,
			label : item.name
		});
	});
	
	
	
	const modeltypeop = [];
	data?.modeltype && data?.modeltype.map((item) => {		
		modeltypeop.push({
			value : item.id,
			label : item.name
		});
	});


		
	const detalgorithmoptions = [];
	data?.detalg && data?.detalg.map((item) => {		
		detalgorithmoptions.push({
			value : item.id,
			label : item.name
		});
	});

	
	
	
	pids.sort((a, b) => { return a.value - b.value; });

	const handleAddFormValuesChange = (changedValues)=>{
		
		const key = Object.keys(changedValues)[0];
		const val = changedValues[key];
		if(key ==='PIDS'){
			getChannels(authtoken,val);
			setFilter({...reportFilter,pidsinfoId:val, channelId : 'all'});
			addMultipleModelsFormik.setFieldValue('pidsinfoId', val);
			addMultipleModelsFormik.setFieldValue('channelinfoId', null);
			form.setFieldValue('channelinfoId', null);
		}

		if(key==='channelinfoId'){
			setFilter({...reportFilter,channelId:val});
			addMultipleModelsFormik.setFieldValue('channelinfoId', val);
		}
	};
			
	const handleupdateFormValuesChange = (changedValues)=>{
		const key = Object.keys(changedValues)[0];
		const val = changedValues[key];
		if(key ==='PIDS'){
			// getChannels(authtoken,val);
			setFilter({...reportFilter,pidsinfoId:val, channelId : 'all'});
			updateMultipleModelsFormik.setFieldValue('pidsinfoId', val);
			updateMultipleModelsFormik.setFieldValue('channelinfoId', null);
			form.setFieldValue('channelinfoId', null);
		}

		if(key==='channelinfoId'){
			setFilter({...reportFilter,channelId:val});
			updateMultipleModelsFormik.setFieldValue('channelinfoId', val);
		}
	};

	const handlepidsfilter = (value) =>{
		setchannels(null);
		setpidsFilter(value);
	};	

	const loadpredicitonlevel= ()=>{
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/predictionlevel/?name=multiple`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
					loadModelClassification(response?.data?.data[0]?.id);
				}
			})
			
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const loadModelClassification = (predictionId)=>{
		dispatch({ type : MODEL_CLASSIFICATIONS });
	
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/modelclassifications/?$sort[id]=1&predictionlevelId=${predictionId}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization':  `Bearer ${authtoken}`
			},
		};
		
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : MODEL_CLASSIFICATIONS_SUCCESS, payload : response.data});
					
				} else {
					dispatch({ type : MODEL_CLASSIFICATIONS_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  'It seems the network is unreachable. Please refresh the application.',
					});
				}
				dispatch({ type : MODEL_CLASSIFICATIONS_ERROR});
			});
	};
	const loaddatagenerationtype = ()=>{
		dispatch({ type : DATA_GENERATIONTYPE });
	
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/datagenerationtype/?pipelineId=1&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization':  `Bearer ${authtoken}`
			},
		};
		
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : DATA_GENERATIONTYPE_SUCCESS, payload : response.data});
				} else {
					dispatch({ type : DATA_GENERATIONTYPE_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  'It seems the network is unreachable. Please refresh the application.',
					});
				}
				dispatch({ type : MODEL_CLASSIFICATIONS_ERROR});
			});
	};

	const loadModeltypes = () => {
		dispatch({ type : MODELTYPE_LIST});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/modeltype?$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
		
		axios.request(config)
			.then((response) => {
	
				if (response.status === 200) {
					dispatch({ type : MODELTYPE_LIST_SUCCESS, payload : response.data});
				}else {
					dispatch({ type : MODELTYPE_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : MODELTYPE_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	
	};
	const loaddetectionalgorithm = () => {
		dispatch({ type : MODELTYPE_LIST});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/detectionalgorithmtype?pipelineId=1&$sort[id]=1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
		
		axios.request(config)
			.then((response) => {
	
				if (response.status === 200) {
					dispatch({ type : DETECTIONALG_LIST_SUCCESS, payload : response.data});
				}else {
					dispatch({ type : DETECTIONALG_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : DETECTIONALG_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});
	
	};

	const handleChainFilter = (value)=>{
		setChainFilter(value);
	};
	
	const handleStatusFilter = (value) => {
		setStatusFilter(value);
	};

	const handlePredictionFilter = (value) => {
		setPredictionFilter(value);
	};

	
	return (
		<>
			<Content>
				<Row
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems: 'center',
					}}
				>
					{/* LEFT SIDE */}
					<Col span={4}>
						<Row>
							<Space>
								<DatabaseOutlined style={{ fontSize: '30px' }} />
								<Title level={4} style={{ paddingTop: '10px' }}>
									{langdata && langdata.MultipleModels
										? langdata.MultipleModels
										: 'Multiple Models'}
								</Title>
							</Space>
						</Row>
					</Col>

					{/* RIGHT SIDE */}
					<Col
						span={20}
						style={{ display: 'flex', justifyContent: 'right' }}
					>
						<Row>
							<Col span={24}>
								<Tooltip
									placement="bottom"
									title={
										langdata && langdata.FilterbyChain
											? langdata.FilterbyChain
											: 'Filter by chain'
									}
								>
									<Space>
										<Select
											style={{ minWidth: '200px', margin: '5px' }}
											showSearch
											filterOption={filterOption}
											placeholder={
												langdata && langdata.SelectPIDS
													? langdata.SelectPIDS
													: 'Select PIDS'
											}
											optionFilterProp="children"
											defaultValue={null}
											options={chainFilter}
											onSelect={handleChainFilter}
										/>
									</Space>
								</Tooltip>

								<Tooltip
									placement="bottom"
									title={
										langdata && langdata.Filterbypids
											? langdata.Filterbypids
											: 'Filter by pids'
									}
								>
									<Space>
										<Select
											style={{ minWidth: '200px', margin: '5px' }}
											showSearch
											filterOption={filterOption}
											placeholder={
												langdata && langdata.SelectPIDS
													? langdata.SelectPIDS
													: 'Select PIDS'
											}
											optionFilterProp="children"
											defaultValue={null}
											options={pidsfilter}
											onSelect={handlepidsfilter}
										/>
									</Space>
								</Tooltip>

								<Tooltip
									placement="bottom"
									title={
										langdata && langdata.Filterbychannel
											? langdata.Filterbychannel
											: 'Filter by channel'
									}
								>
									<Space>
										<Select
											style={{ minWidth: '200px', margin: '5px' }}
											showSearch
											filterOption={filterOption}
											placeholder={
												langdata && langdata.SelectChannel
													? langdata.SelectChannel
													: 'Select Channel'
											}
											optionFilterProp="children"
											value={channelsdata}
											options={channels}
											disabled={pidsFilter == null}
											onSelect={(e) =>
												handleSetChannel(e, 'channels')
											}
										/>
									</Space>
								</Tooltip>
								<Tooltip
									placement="bottom"
									title={
										langdata && langdata.Filterbystatus
											? langdata.Filterbystatus
											: 'Filter by Status'
									}
								>
									<Space>
										<Select
											style={{ minWidth: '200px', margin: '5px' }}
											showSearch
											filterOption={filterOption}
											placeholder={
												langdata && langdata.SelectStatus
													? langdata.SelectStatus
													: 'Select Status'
											}
											optionFilterProp="children"
											defaultValue={null}
											options={statusArray}
											onSelect={handleStatusFilter}
										/>
									</Space>
								</Tooltip>

								<Tooltip
									placement="bottom"
									title={
										langdata && langdata.filterbymodelprediction
											? langdata.filterbymodelprediction
											: 'Filter by model prediction'
									}
								>
									<Space>
										<Select
											style={{ minWidth: '200px', margin: '5px' }}
											showSearch
											filterOption={filterOption}
											placeholder={
												langdata && langdata.SelectModelPrediction
													? langdata.SelectModelPrediction
													: 'Select Model prediction'
											}
											optionFilterProp="children"
											defaultValue={null}
											options={predictionArray}
											onSelect={handlePredictionFilter}
										/>
									</Space>
								</Tooltip>

								<Tooltip
									placement="bottom"
									title={
										langdata && langdata.Add
											? langdata.Add
											: 'Add'
									}
								>
									<Space>
										{permission === 'superadmin' ||
						permission === 'admin' ? (
												<Button
													type="primary"
													onClick={openAddVehicleStatusModal}
													style={{ margin: '5px' }}
												>
													<PlusOutlined />
													{langdata && langdata.AddNew
														? langdata.AddNew
														: 'Add New'}
												</Button>
											) : null}
									</Space>
								</Tooltip>

								<Space>&nbsp;&nbsp;</Space>

								<Space>
									<Typography>
										<Popover
											title={
												langdata && langdata.MultipleModels
													? langdata.MultipleModels
													: 'Multiple Models'
											}
											content={infoContent}
											trigger="click"
										>
											<Avatar size="small">
												<InfoOutlined />
											</Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={24}>
						{ data && data.multimod.length > 0 ? (
							<Table
								scroll={{
									x: 900,
								}} 
								columns={columns} 
								dataSource={data && data.multimod} 
								onChange={loadMultiplemodels}
								onRow = {() => {
									return {
										onClick: () => { 
										}
									};
								}} />
						)
							:
							(
								<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
							)}
					</Col>
				</Row>
			</Content>

			<Spin fullscreen spinning={data.pending} />
      
			{/*  Add Multiple Models Starts */}
			<Modal
				title={ langdata&&langdata.AddMultipleModels?langdata.AddMultipleModels:'Add Multiple Models' }
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={ShowAddMultipleModelsModal}
				onOk={{cloaseMultipleModelsModal}}
				onCancel={cloaseMultipleModelsModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={cloaseMultipleModelsModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addMultipleModelsFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
					</Space>
				]}
				width={800}
			>
				<Form layout="vertical"  onSubmit={addMultipleModelsFormik.handleSubmit} form={form} onValuesChange={handleAddFormValuesChange}>
					<Row gutter={24} >
						<Col span={22}>
							<Badge.Ribbon text={addMultipleModelsFormik.values.modelPrediction == false ? langdata && langdata.DetectionAlgorithmEnabled ? langdata.DetectionAlgorithmEnabled : 'Detection Algorithm Enabled' : langdata && langdata.ModelPredictionEnabled ? langdata.ModelPredictionEnabled : 'Model Prediction Enabled'}
								style={{ marginTop: '10px' }}
								color={addMultipleModelsFormik.values.modelPrediction == false ? '#a81e1e' : '#179668'}>
								<Form.Item  name="name" label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} required>
									<Input name="name" onChange={addMultipleModelsFormik.handleChange} 
										placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} 
									/>
								</Form.Item>
							</Badge.Ribbon>
						</Col>
						<Col span={2}>
							<Form.Item 
								// label={langdata && langdata.modelPrediction ? langdata.modelPrediction:'Model Prediction'} 
								rules={[{ required: false}]} >
								<Switch size='small'  onChange={(value) => modelpredictionhandler(value,'add')}  defaultChecked={true}
									style={{marginTop:'38px'}}/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="PIDS" label={ langdata&&langdata.PIDS?langdata.PIDS:'PIDS'} rules={[{ required: true, message: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}]} >
								<Select Item
									name="PIDS"
									style={{ width: '100%'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
									optionFilterProp="children"
									// value={reportFilter.pidsinfoId}
									value={reportFilter.pidsinfoId}
									onSelect={(value)=>{handleAddFormValuesChange({'PIDS': value});}}             
									options={pids}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="channelinfoId" label={ langdata&&langdata.channelName?langdata.channelName:'channel Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'PleaseEnterChannelName'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="channelinfoId"
									showSearch
									filterOption={filterOption}
									disabled={reportFilter.pidsinfoId ? false :true}
									placeholder={langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'}
									optionFilterProp="children"	
									onSelect={(value)=>{handleAddFormValuesChange({'channelinfoId': value});}}
									value={addMultipleModelsFormik.values.channelinfoId}
									// onSelect={handleSetChannel}
									options={channels}
									
								/>
							</Form.Item>
						</Col>
					</Row>
					{ addMultipleModelsFormik.values.modelPrediction === true ? 
						<>
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item name="modeltypeId" label={ langdata&&langdata.ModelType?langdata.ModelType:'Model Type'} rules={[{ required: false, message: langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype :'Select model type'}]} >
										<Select Item
											style={{ width : '100%'}}
											name="modeltypeId"
											showSearch
											filterOption={filterOption}
											placeholder={langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype :'Select model type'}
											optionFilterProp="children"	
											onChange={(value) => addMultipleModelsFormik.setFieldValue('modeltypeId', value)}
											options={modeltypeop}
									
										/>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item name="modelclassificationId" label={ langdata&&langdata.ModelName?langdata.ModelName:'Model Name'} rules={[{ required: false, message: langdata && langdata.PleaseSelectModelclass ? langdata.PleaseSelectModelclass :'Please  Select Model class'}]} >
										<Select Item
											style={{ width : '100%'}}
											name="modelclassificationId"
											showSearch
											filterOption={filterOption}
											placeholder={langdata && langdata.PleaseSelectModelclass ? langdata.PleaseSelectModelclass :'Please  Select Model class'}
											optionFilterProp="children"	
											onChange={(value) => addMultipleModelsFormik.setFieldValue('modelclassificationId', value)}
											value={addMultipleModelsFormik.values.channelinfoId}
											// onSelect={handleSetChannel}
											options={modelclassop}
									
										/>
									</Form.Item>
								</Col>
							</Row> 
						</> :
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="detectionalgorithmtypeId" label={ langdata&&langdata.DetectionAlgorithm?langdata.DetectionAlgorithm:'Detection Algorithm'} rules={[{ required: false, message: langdata && langdata.PleaseSelectDetectionAlgorithm ? langdata.PleaseSelectDetectionAlgorithm :'Please Select detection algorithm'}]} >
									<Select Item
										style={{ width : '100%'}}
										name="detectionalgorithmtypeId"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.PleaseSelectDetectionAlgorithm ? langdata.PleaseSelectDetectionAlgorithm :'Please Select detection algorithm'}
										optionFilterProp="children"	
										onChange={(value) => addMultipleModelsFormik.setFieldValue('detectionalgorithmtypeId', value)}
										options={detalgorithmoptions}
									
									/>
								</Form.Item>
							</Col>
						</Row>
					}
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Filters ? langdata.Filters : 'Filters'} name="wellalgorithmId" rules={[{ required: false , message : langdata && langdata.PleaseSelectWellAlgorithm ? langdata.PleaseSelectWellAlgorithm : 'Please Select Well Algorithm' }]}>
								<Select Item
									name="wellalgorithmId"
									mode="multiple"
									showSearch
									placeholder={langdata && langdata.PleaseSelectWellAlgorithm ? langdata.PleaseSelectWellAlgorithm : 'Please Select Well Algorithm' }
									optionFilterProp="children"
									filterOption={filterOption}
									options={algoritham}
									onChange={(value) => addMultipleModelsFormik.setFieldValue('wellalgorithmId', value)}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name='algtag' >
								<Tag name='algtag' style={{
									maxWidth: '100%',
									whiteSpace: 'normal',
									wordBreak: 'break-word',
									lineHeight: '1.9'
								}} color="blue">{langdata && langdata.Filtertypes ? langdata.Filtertypes : 'Filter types' } {'['}{addMultipleModelsFormik.values && addMultipleModelsFormik.values.wellalgorithmId &&<Space wrap>
										{addMultipleModelsFormik.values.wellalgorithmId.map(item => {
											const alg = algoritham.find(a => a.value === item);
											return (
												<>
													{alg?.label}
												</>
											);
										})}
									</Space>}{']'} </Tag>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="datagenerationtypeId" label={ langdata&&langdata.DataGenerationType?langdata.DataGenerationType:'Data Generation Type'} rules={[{ required: false, message: langdata && langdata.PleaseSelectDataGenerationType ? langdata.PleaseSelectDataGenerationType :'Please Select Data Generation Type'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="datagenerationtypeId"
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.PleaseSelectDataGenerationType ? langdata.PleaseSelectDataGenerationType :'Please Select Data Generation Type'}
									optionFilterProp="children"	
									onChange={(value) => addMultipleModelsFormik.setFieldValue('datagenerationtypeId', value)}
									options={datagenop}
									
								/>
							</Form.Item>
						</Col>
					</Row>
					
					{ addMultipleModelsFormik.values.modelPrediction  === true ?<>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="confidenceThreshold" label={langdata&&langdata.ConfidenceThreshold?langdata.ConfidenceThreshold:'Confidence Threshold'} rules={[{ required: false, message: langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please Enter confidence Threshold' }]} >
									<InputNumber 
										name="confidenceThreshold" 
										style={
											{
												width : '100%'
											}
										}
										stringMode
										step={0.1}
										min={0}
										onChange={(value) => addMultipleModelsFormik.setFieldValue('confidenceThreshold', value)} 
										placeholder={langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please Enter confidence Threshold' } />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.modelPath ? langdata.modelPath : 'Model Path'} rules={[{ required: false, message: langdata && langdata.PleaseEnterModelPath ? langdata.PleaseEnterModelPath : 'Please the enter Model Path' }]} >
									<Input 
										name="modelPath" 
										onChange={addMultipleModelsFormik.handleChange} 
										placeholder={langdata && langdata.PleaseEnterModelPath ? langdata.PleaseEnterModelPath : 'Please the enter Model Path'} 
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.curlPath ? langdata.curlPath : 'Curl Path'} rules={[{ required: false, message: langdata && langdata.PleaseEnterCurlPath ? langdata.PleaseEnterCurlPath : 'Please the enter Curl Path' }]} >
									<Input 
										name="curlPath" 
										onChange={addMultipleModelsFormik.handleChange} 
										placeholder={langdata && langdata.PleaseEnterCurlPath ? langdata.PleaseEnterCurlPath : 'Please the enter the curl path'} 
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.PickleFilePath ? langdata.PickleFilePath : 'Pickle File Path'} rules={[{ required: false, message: langdata && langdata.PleaseEnterPickleFilePath ? langdata.PleaseEnterPickleFilePath : 'Please Enter Pickle File Path' }]}>
									<Input 
										name="pickleFilePath" 
										onChange={addMultipleModelsFormik.handleChange} 
										placeholder={langdata && langdata.PleaseEnterPickleFilePath ? langdata.PleaseEnterPickleFilePath : 'Please Enter Pickle File Path' } 
									/>
								</Form.Item>
							</Col>
						</Row> </> : null}


					<Row justify="start" style={{marginBottom: '5px'}}>
						<Col>
							<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
								<Typography>
									{langdata?.subChain || 'Sub Chain'}
								</Typography>
								<Switch
									size="small"
									onChange={(e) => handleSubChainToggle(e,'add')}
								/>
							</div>
						</Col>
					</Row>

					{addMultipleModelsFormik.values.isSubChain == true ? 
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata.SubChainActivity?langdata.SubChainActivity:'SubChain Activity'} name="mainClass" rules={[{ required: true , message : langdata && langdata.PleaseSelectSubChainActivity ? langdata.PleaseSelectSubChainActivity : 'Please Select SubChain Activity'}]}>
									<Select Item
										name="mainClass"
										showSearch
										placeholder={langdata && langdata.PleaseSelectSubChainActivity ? langdata.PleaseSelectSubChainActivity : 'Please Select SubChain Activity'}
										optionFilterProp="children"
										filterOption={filterOption}
										options={allevents}
										onChange={(value) => addMultipleModelsFormik.setFieldValue('mainClass', value)}
									/>
								</Form.Item>
							</Col>
						</Row> : ''}


				</Form>
			</Modal>
			{/* Add Multiple Models Ends */}

			{/* Edit Multiple Models Starts */}
			<Modal
				
				title={ langdata&&langdata.EditMultiplemodelconfig?langdata.EditMultiplemodelconfig:'Edit Multiple Models'}
				centered
				destroyOnClose={true}
				maskClosable={false}
				open={ShowEditMultipleModelsModal}
				onOk={{closeEditMultipleModelsModal}}
				onCancel={closeEditMultipleModelsModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeEditMultipleModelsModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
						<Button type="primary" onClick={updateMultipleModelsFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> 
					</Space>
				]}
				width={800}
			>

				<Form layout="vertical" onSubmit={updateMultipleModelsFormik.handleSubmit} form={form} onChange={handleupdateFormValuesChange} >
					<Row gutter={24}>

						
						<Col span={22}>
							<Badge.Ribbon text={updateMultipleModelsFormik.values.modelPrediction == false ? langdata && langdata.DetectionAlgorithmEnabled ? langdata.DetectionAlgorithmEnabled : 'Detection Algorithm Enabled' : langdata && langdata.ModelPredictionEnabled ? langdata.ModelPredictionEnabled : 'Model Prediction Enabled'}
								style={{ marginTop: '10px' }}
								color={updateMultipleModelsFormik.values.modelPrediction == false ? '#a81e1e' : '#179668'}>
								<Form.Item  name="name" label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} required>
									<Input name="name"   onChange={updateMultipleModelsFormik.handleChange} 
										placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} 
										defaultValue={updateMultipleModelsFormik.values.name} 
									/>
								</Form.Item>
							</Badge.Ribbon>
						</Col>
						<Col span={2}>
							<Form.Item 
								// label={langdata && langdata.modelPrediction ? langdata.modelPrediction:'Model Prediction'} 
								rules={[{ required: false}]} >
								<Switch size='small'  onChange={(value) => modelpredictionhandler(value,'edit')}  defaultValue={updateMultipleModelsFormik.values.modelPrediction}
									style={{marginTop:'38px'}}/>
							</Form.Item>
						</Col>
						
						{/* <Col span={19}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{required : false,message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]}>
								<Input 
									name="name" onChange={updateMultipleModelsFormik.handleChange} 
									placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'}
									defaultValue={updateMultipleModelsFormik.values.name} 
								/>
							</Form.Item>
						</Col>
						<Col span={5}>
							<Form.Item label={langdata && langdata.modelPrediction ? langdata.modelPrediction:'Model Prediction'} rules={[{ required: false}]} >
								<Switch size='small'  onChange={(value) => modelpredictionhandler(value,'edit')}  defaultValue={updateMultipleModelsFormik.values.modelPrediction}/>
							</Form.Item>
						</Col> */}
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="PIDS" label={ langdata&&langdata.PIDS?langdata.PIDS:'PIDS'} rules={[{ required : true,message: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}]} >
								<Select Item
									name="PIDS"
									style={{ width: '100%'}}
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
									optionFilterProp="children"
									onSelect={(value)=>{handleupdateFormValuesChange({'PIDS': value});}}         	
									// value={reportFilter.pidsinfoId}
									defaultValue={updateMultipleModelsFormik.values.pidsinfoId}
									// value={reportFilter.pidsinfoId}
									options={pids}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="channelinfoId" label={ langdata&&langdata.channelName?langdata.channelName:'channel Name'} rules={[{ required : true,message: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="channelinfoId"
									showSearch
									filterOption={filterOption}
									disabled={channels.length > 1 || reportFilter.pidsinfoId ? false :true}
									placeholder={langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'}
									optionFilterProp="children"
									defaultValue={updateMultipleModelsFormik.values.channelinfoId} 
									onSelect={(value)=>{handleupdateFormValuesChange({'channelinfoId': value});}}  
									options={channels}
								/>
							</Form.Item>
						</Col>
					</Row>

					{updateMultipleModelsFormik.values.modelPrediction === true ? <>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="modeltypeId" label={ langdata&&langdata.ModelType?langdata.ModelType:'Model Type'} rules={[{required : false,message: langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype :'Select model type'}]} >
									<Select Item
										style={{ width : '100%'}}
										name="modeltypeId"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Selectmodeltype ? langdata.Selectmodeltype :'Select model type'}
										optionFilterProp="children"	
										onChange={(value) => updateMultipleModelsFormik.setFieldValue('modeltypeId', value)}
										defaultValue={updateMultipleModelsFormik.values.modeltypeId} 
										options={modeltypeop}
									
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="modelclassificationId" label={ langdata&&langdata.ModelName?langdata.ModelName:'Model Name'} rules={[{required : false, message: langdata && langdata.PleaseSelectModelclass ? langdata.PleaseSelectModelclass :'Please  Select Model class'}]} >
									<Select Item
										style={{ width : '100%'}}
										name="modelclassificationId"
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.PleaseSelectModelclass ? langdata.PleaseSelectModelclass :'Please  Select Model class'}
										optionFilterProp="children"	
										// onSelect={(value)=>{handleupdateFormValuesChange({'modelclassificationId': value});}}
										onChange={(value) => updateMultipleModelsFormik.setFieldValue('modelclassificationId', value)}
										defaultValue={updateMultipleModelsFormik.values.modelclassificationId} 
										// onSelect={handleSetChannel}
										options={modelclassop}
									
									/>
								</Form.Item>
							</Col>
						</Row>
					</> :<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="detectionalgorithmtypeId" label={ langdata&&langdata.DetectionAlgorithm?langdata.DetectionAlgorithm:'Detection Algorithm'} rules={[{ required: false, message: langdata && langdata.PleaseSelectDetectionAlgorithm ? langdata.PleaseSelectDetectionAlgorithm :'Please Select detection algorithm'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="detectionalgorithmtypeId"
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.PleaseSelectDetectionAlgorithm ? langdata.PleaseSelectDetectionAlgorithm :'Please Select detection algorithm'}
									optionFilterProp="children"	
									onChange={(value) => updateMultipleModelsFormik.setFieldValue('detectionalgorithmtypeId', value)}
									defaultValue={updateMultipleModelsFormik.values.detectionalgorithmtypeId} 
									options={detalgorithmoptions}
									
								/>
							</Form.Item>
						</Col>
					</Row>}
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Filters ? langdata.Filters : 'Filters'} name="wellalgorithmId" rules={[{required : false,message : langdata && langdata.PleaseSelectWellAlgorithm ? langdata.PleaseSelectWellAlgorithm : 'Please Select Well Algorithm' }]}>
								<Select Item
									name="wellalgorithmId"
									mode="multiple"
									showSearch
									placeholder={langdata && langdata.PleaseSelectWellAlgorithm ? langdata.PleaseSelectWellAlgorithm : 'Please Select Well Algorithm' }
									optionFilterProp="children"
									filterOption={filterOption}
									options={algoritham}
									defaultValue={updateMultipleModelsFormik.values.wellalgorithmId} 
									onChange={(value) => updateMultipleModelsFormik.setFieldValue('wellalgorithmId', value)}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name='algtag' >
								<Tag name='algtag' style={{
									maxWidth: '100%',
									whiteSpace: 'normal',
									wordBreak: 'break-word',
									lineHeight: '1.9'
								}} color="blue">{langdata && langdata.Filtertypes ? langdata.Filtertypes : 'Filter types' } {'['}{updateMultipleModelsFormik.values && updateMultipleModelsFormik.values.wellalgorithmId &&<Space wrap>
										{updateMultipleModelsFormik.values.wellalgorithmId.map(item => {
											const alg = algoritham.find(a => a.value === item);
											return (
												<>
													{alg?.label}
												</>
											);
										})}
									</Space>}{']'} </Tag>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item name="datagenerationtypeId" label={ langdata&&langdata.DataGenerationType?langdata.DataGenerationType:'Data Generation'} rules={[{required : false,message: langdata && langdata.PleaseSelectDataGenerationType ? langdata.PleaseSelectDataGenerationType :'Please Select Data Generation Type'}]} >
								<Select Item
									style={{ width : '100%'}}
									name="datagenerationtypeId"
									showSearch
									filterOption={filterOption}
									placeholder={langdata && langdata.PleaseSelectDataGenerationType ? langdata.PleaseSelectDataGenerationType :'Please Select Data Generation Type'}
									optionFilterProp="children"	
									// onSelect={(value)=>{handleupdateFormValuesChange({'datagenerationtypeId': value});}}
									onChange={(value) => updateMultipleModelsFormik.setFieldValue('datagenerationtypeId', value)}
									defaultValue={updateMultipleModelsFormik?.values?.datagenerationtypeId  ? updateMultipleModelsFormik.values.datagenerationtypeId  : null} 

									// onSelect={handleSetChannel}
									options={datagenop}
									
								/>
							</Form.Item>
						</Col>
					</Row>
					

					{updateMultipleModelsFormik.values.modelPrediction === true ?
						<>
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item name="confidenceThreshold" label={langdata&&langdata.ConfidenceThreshold?langdata.ConfidenceThreshold:'Confidence Threshold'} rules={[{required : false,message: langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please Enter confidence Threshold' }]} >
										<InputNumber 
											name="confidenceThreshold" 
											style={
												{
													width : '100%'
												}
											}
											stringMode
											step={0.1}
											min={0}
											onChange={(value) => updateMultipleModelsFormik.setFieldValue('confidenceThreshold', value)} 
											defaultValue={updateMultipleModelsFormik.values.confidenceThreshold} 
											placeholder={langdata&&langdata.PleaseEnterconfidenceThreshold?langdata.PleaseEnterconfidenceThreshold:'Please Enter confidence Threshold'} />
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.modelPath ? langdata.modelPath : 'Model Path'} rules={[{ required : false, message: langdata && langdata.PleaseEnterModelPath ? langdata.PleaseEnterModelPath : 'Please the enter Model Path' }]} >
										<Input 
											name="modelPath" 
											onChange={updateMultipleModelsFormik.handleChange} 
											defaultValue={updateMultipleModelsFormik.values.modelPath} 
											placeholder={langdata && langdata.PleaseEnterModelPath ? langdata.PleaseEnterModelPath : 'Please the enter Model Path'} 
										/>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.curlPath ? langdata.curlPath : 'Curl Path'} rules={[{ required : false, message: langdata && langdata.PleaseEnterCurlPath ? langdata.PleaseEnterCurlPath : 'Please the enter curl path' }]} >
										<Input 
											name="curlPath" 
											onChange={updateMultipleModelsFormik.handleChange} 
											defaultValue={updateMultipleModelsFormik.values.curlPath} 
											placeholder={langdata && langdata.PleaseEnterCurlPath ? langdata.PleaseEnterCurlPath : 'Please the enter curl path'} 
										/>
									</Form.Item>
								</Col>
							</Row>
							<Row gutter={24}>
								<Col span={24}>
									<Form.Item label={langdata && langdata.PickleFilePath ? langdata.PickleFilePath : 'Pickle File Path'} rules={[{ required: false, message: langdata && langdata.PleaseEnterPickleFilePath ? langdata.PleaseEnterPickleFilePath : 'Please Enter Pickle File Path' }]}>
										<Input 
											name="pickleFilePath" 
											onChange={updateMultipleModelsFormik.handleChange} 
											defaultValue={updateMultipleModelsFormik.values.pickleFilePath} 
											placeholder={langdata && langdata.PleaseEnterPickleFilePath ? langdata.PleaseEnterPickleFilePath : 'Please Enter Pickle File Path' } 
										/>
									</Form.Item>
								</Col>
							</Row> </>: null}

					<Row justify="start" style={{marginBottom: '5px'}}>
						<Col>
							<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
								<Typography>
									{langdata?.subChain || 'Sub Chain'}
								</Typography>
								<Switch
									checked={updateMultipleModelsFormik.values.isSubChain} 
									size="small"
									onChange={(e) => handleSubChainToggle(e,'edit')}
								/>
							</div>
						</Col>
					</Row>

					

					{updateMultipleModelsFormik.values.isSubChain == true ? 
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata.SubChainActivity?langdata.SubChainActivity:'SubChain Activity'} name="mainClass" rules={[{ required : false, message : langdata && langdata.PleaseSelectSubChainActivity ? langdata.PleaseSelectSubChainActivity : 'Please Select SubChain Activity' }]}>
									<Select Item
										name="mainClass"
										showSearch
										placeholder={langdata && langdata.PleaseSelectSubChainActivity ? langdata.PleaseSelectSubChainActivity : 'Please Select SubChain Activity'}
										optionFilterProp="children"
										filterOption={filterOption}
										options={allevents}
										defaultValue={updateMultipleModelsFormik.values.mainClass}
										onChange={(value) => updateMultipleModelsFormik.setFieldValue('mainClass', value)}
									/>
								</Form.Item>
							</Col>
						</Row> : ''}


				</Form>
			</Modal>
			{/* Edit Multiple Models  Ends */}

			{/* Delete  Multiple Models  Starts */}
			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteMultipleModelsModal} onOk={deleteMultipleModelsStatus} onCancel={closeDeleteMultipleModelsModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> { langdata && langdata.ConfirmDeleteMultipleModels?langdata.ConfirmDeleteMultipleModels:'Are you sure you want to delete this Multiple Models Configuration ?' }</Col>
				</Row>
			</Modal>
			{/* Delete  Multiple Models  Ends */}
		</> 
	);
}